import { render, staticRenderFns } from "./TipsText.vue?vue&type=template&id=b2b472b0&scoped=true"
import script from "./TipsText.vue?vue&type=script&lang=js"
export * from "./TipsText.vue?vue&type=script&lang=js"
import style0 from "./TipsText.vue?vue&type=style&index=0&id=b2b472b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b472b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2b472b0')) {
      api.createRecord('b2b472b0', component.options)
    } else {
      api.reload('b2b472b0', component.options)
    }
    module.hot.accept("./TipsText.vue?vue&type=template&id=b2b472b0&scoped=true", function () {
      api.rerender('b2b472b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/skinSetting/components/TipsText.vue"
export default component.exports